// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Premium Editorial Blog Detail Page */

.blogdetail-wrapper {
  min-height: 100vh;
  background: #ffffff;
  padding: 0;
  margin: 0;
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* We hide the local blogdetail-navbar because the global Navbar is now always visible */
.blogdetail-navbar {
  display: none;
}

/* Content Container */
.blogdetail-inner {
  width: 100%;
  padding-top: 80px; /* Offset for global navbar */
}

.blogdetail-article {
  width: 100%;
  max-width: 100vw;
  margin: 0 auto;
  background: #ffffff;
}

/* Header Section */
.blogdetail-header {
  max-width: 900px;
  margin: 0 auto;
  padding: 5rem 2rem 3rem;
  text-align: center;
}

.blogdetail-category {
  display: inline-block;
  padding: 0;
  background: transparent;
  color: #000000;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  margin-bottom: 2rem;
  border-bottom: 2px solid #000;
}

.blogdetail-title {
  font-size: clamp(2.5rem, 6vw, 4.5rem);
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-weight: 800;
  color: #000000;
  line-height: 1.15;
  margin-bottom: 2.5rem;
  letter-spacing: -0.02em;
}

.blogdetail-meta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  color: #4b5563;
  font-size: 0.95rem;
  font-weight: 500;
}

.blogdetail-meta-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.blogdetail-meta-divider {
  color: #d1d5db;
  font-weight: 300;
}

/* Hero Image */
.blogdetail-image {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto 5rem;
  aspect-ratio: 21/9;
  background: #f3f4f6;
  border-radius: 16px;
  overflow: hidden;
}

.blogdetail-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Article Body */
.blogdetail-body {
  max-width: 760px;
  margin: 0 auto;
  padding: 0 1.5rem 6rem;
}

.blogdetail-lead {
  font-size: clamp(1.2rem, 3vw, 1.45rem);
  line-height: 1.8;
  color: #1a1a1a;
  font-weight: 400;
  margin-bottom: 4rem;
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-style: italic;
  text-align: center;
}

.blogdetail-sections {
  display: flex;
  flex-direction: column;
  gap: 3.5rem;
}

.blogdetail-section h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #000000;
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.blogdetail-section p {
  font-size: 1.125rem;
  line-height: 1.85;
  color: #374151;
  margin-bottom: 1.5rem;
}

.blogdetail-section blockquote {
  margin: 3rem 0;
  padding: 0 0 0 2rem;
  border-left: 2px solid #000000;
  font-size: 1.5rem;
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-style: italic;
  color: #000000;
  line-height: 1.6;
}

.blogdetail-conclusion {
  background: #FAF9F6;
  padding: 3rem;
  border-radius: 12px;
  margin-top: 4rem;
}

.blogdetail-conclusion h2 {
  margin-bottom: 1rem;
}

.blogdetail-conclusion p {
  margin-bottom: 0;
}

/* Footer Section */
.blogdetail-footer {
  margin-top: 5rem;
  padding-top: 3rem;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
}

.blogdetail-share {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.blogdetail-share span {
  font-weight: 600;
  color: #000000;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

.blogdetail-share-icons {
  display: flex;
  gap: 0.75rem;
}

.blogdetail-share-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f3f4f6;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  cursor: pointer;
  transition: all 0.3s ease;
}

.blogdetail-share-btn:hover {
  background: #000000;
  color: #ffffff;
  transform: translateY(-2px);
}

.blogdetail-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 2rem;
  background: transparent;
  color: #000000;
  border: 1px solid #000000;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.95rem;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
}

.blogdetail-btn:hover {
  background: #000000;
  color: #ffffff;
}

/* Responsive */
@media (max-width: 768px) {
  .blogdetail-header {
    padding: 3rem 1.5rem 2rem;
  }
  
  .blogdetail-title {
    font-size: 2.5rem;
  }
  
  .blogdetail-meta {
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .blogdetail-meta-divider {
    display: none;
  }

  .blogdetail-image {
    border-radius: 0;
    margin-bottom: 3rem;
  }

  .blogdetail-conclusion {
    padding: 2rem 1.5rem;
  }

  .blogdetail-section blockquote {
    font-size: 1.25rem;
    padding-left: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/blog-detail.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,iFAAiF;AACnF;;AAEA,wFAAwF;AACxF;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,iBAAiB,EAAE,6BAA6B;AAClD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,iFAAiF;EACjF,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iFAAiF;EACjF,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,iFAAiF;AACnF;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,iFAAiF;EACjF,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF","sourcesContent":["/* Premium Editorial Blog Detail Page */\n\n.blogdetail-wrapper {\n  min-height: 100vh;\n  background: #ffffff;\n  padding: 0;\n  margin: 0;\n  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n/* We hide the local blogdetail-navbar because the global Navbar is now always visible */\n.blogdetail-navbar {\n  display: none;\n}\n\n/* Content Container */\n.blogdetail-inner {\n  width: 100%;\n  padding-top: 80px; /* Offset for global navbar */\n}\n\n.blogdetail-article {\n  width: 100%;\n  max-width: 100vw;\n  margin: 0 auto;\n  background: #ffffff;\n}\n\n/* Header Section */\n.blogdetail-header {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 5rem 2rem 3rem;\n  text-align: center;\n}\n\n.blogdetail-category {\n  display: inline-block;\n  padding: 0;\n  background: transparent;\n  color: #000000;\n  font-size: 0.85rem;\n  font-weight: 700;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  margin-bottom: 2rem;\n  border-bottom: 2px solid #000;\n}\n\n.blogdetail-title {\n  font-size: clamp(2.5rem, 6vw, 4.5rem);\n  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  font-weight: 800;\n  color: #000000;\n  line-height: 1.15;\n  margin-bottom: 2.5rem;\n  letter-spacing: -0.02em;\n}\n\n.blogdetail-meta {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1.5rem;\n  color: #4b5563;\n  font-size: 0.95rem;\n  font-weight: 500;\n}\n\n.blogdetail-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.blogdetail-meta-divider {\n  color: #d1d5db;\n  font-weight: 300;\n}\n\n/* Hero Image */\n.blogdetail-image {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto 5rem;\n  aspect-ratio: 21/9;\n  background: #f3f4f6;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.blogdetail-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Article Body */\n.blogdetail-body {\n  max-width: 760px;\n  margin: 0 auto;\n  padding: 0 1.5rem 6rem;\n}\n\n.blogdetail-lead {\n  font-size: clamp(1.2rem, 3vw, 1.45rem);\n  line-height: 1.8;\n  color: #1a1a1a;\n  font-weight: 400;\n  margin-bottom: 4rem;\n  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  font-style: italic;\n  text-align: center;\n}\n\n.blogdetail-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 3.5rem;\n}\n\n.blogdetail-section h2 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #000000;\n  margin-bottom: 1.5rem;\n  letter-spacing: -0.02em;\n  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.blogdetail-section p {\n  font-size: 1.125rem;\n  line-height: 1.85;\n  color: #374151;\n  margin-bottom: 1.5rem;\n}\n\n.blogdetail-section blockquote {\n  margin: 3rem 0;\n  padding: 0 0 0 2rem;\n  border-left: 2px solid #000000;\n  font-size: 1.5rem;\n  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  font-style: italic;\n  color: #000000;\n  line-height: 1.6;\n}\n\n.blogdetail-conclusion {\n  background: #FAF9F6;\n  padding: 3rem;\n  border-radius: 12px;\n  margin-top: 4rem;\n}\n\n.blogdetail-conclusion h2 {\n  margin-bottom: 1rem;\n}\n\n.blogdetail-conclusion p {\n  margin-bottom: 0;\n}\n\n/* Footer Section */\n.blogdetail-footer {\n  margin-top: 5rem;\n  padding-top: 3rem;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 2rem;\n}\n\n.blogdetail-share {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.blogdetail-share span {\n  font-weight: 600;\n  color: #000000;\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n}\n\n.blogdetail-share-icons {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.blogdetail-share-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #f3f4f6;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #000000;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.blogdetail-share-btn:hover {\n  background: #000000;\n  color: #ffffff;\n  transform: translateY(-2px);\n}\n\n.blogdetail-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 2rem;\n  background: transparent;\n  color: #000000;\n  border: 1px solid #000000;\n  border-radius: 999px;\n  font-weight: 600;\n  font-size: 0.95rem;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.blogdetail-btn:hover {\n  background: #000000;\n  color: #ffffff;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .blogdetail-header {\n    padding: 3rem 1.5rem 2rem;\n  }\n  \n  .blogdetail-title {\n    font-size: 2.5rem;\n  }\n  \n  .blogdetail-meta {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n  \n  .blogdetail-meta-divider {\n    display: none;\n  }\n\n  .blogdetail-image {\n    border-radius: 0;\n    margin-bottom: 3rem;\n  }\n\n  .blogdetail-conclusion {\n    padding: 2rem 1.5rem;\n  }\n\n  .blogdetail-section blockquote {\n    font-size: 1.25rem;\n    padding-left: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
